<div class="session">
  <mat-card class="overflow-hidden">
    <div fxLayout="row wrap">
      <div fxFlex.gt-xs="50" fxFlex="100" class="bg-image bg-image-signin">
        <div fxLayout="row" fxLayoutAlign="space-evenly center" class="h-100 py-3">
          <div class="text-xs-center pb-1 mat-text-white">
              <img src="assets/images/vias_logo_en.png" width="280"/>
          </div>
        </div>
      </div>
      <div fxFlex.gt-xs="50" fxFlex="100">
        <mat-card-content class="pa-3">
          <h1 class="mb-0">{{'pageNames.page_1'|translate}}</h1>
          <!-- <p class="mat-text-muted text-md mt-0 mb-2">Lutfen kullanici adinizi ve sifrenizi girin</p> -->
          <p class="mat-text-warn" #errorTxt></p>
          <form [formGroup]="form" (ngSubmit)="login()">
            <div fxLayout="column" fxLayoutAlign="space-around">
              <div class="pb-1">
                <mat-form-field style="width: 100%">
                  <input matInput placeholder="{{'userName'|translate}}" [formControl]="form.controls['username']">
                  <mat-icon matSuffix>person</mat-icon>
                </mat-form-field>
                <small *ngIf="form.controls['username'].hasError('required') && form.controls['username'].touched" class="mat-text-warn">
                  {{'errorTexts.e_0000_001'|translate}}</small>
              </div>
              <div class="pb-1">
                <mat-form-field style="width: 100%">
                  <input matInput type="password" placeholder="{{'password'|translate}}" [formControl]="form.controls['password']">
                  <mat-icon matSuffix>lock</mat-icon>
                </mat-form-field>
                <small *ngIf="form.controls['password'].hasError('required') && form.controls['password'].touched"
                  class="mat-text-warn">{{'errorTexts.e_0000_002'|translate}}</small>
              </div>
              <div class="text-xs-right" style="color: blue;">
                <a (click)="onForgotPass()">{{'forgotPass' | translate}}</a>
              </div>
              <div class="pb-1">
                <mat-checkbox [formControl]="form.controls['remember']" >{{ 'rememberMe' | translate}}</mat-checkbox>
              </div>
              <button mat-raised-button color="primary" type="submit" [disabled]="!form.valid">{{'login'|translate}}</button>
            </div>
            <!-- <div class="pt-1 pb-1 text-xs-center">
              <a [routerLink]="['/account/forgot']">Sifremi unuttum</a>
            </div> -->
          </form>
        </mat-card-content>
      </div>
    </div>
  </mat-card>
</div>
